export function adsBlocked() {
  const adsbox = window.document.getElementsByClassName("adsbox");
  const faviconAd = window.document.getElementsByClassName("faviconAd");
  return (adsbox.length === 1 && adsbox[0].clientHeight < 20 && faviconAd.length === 1 && faviconAd[0].clientHeight < 20) || !window['canRunAds'] || !window['canRunAds2'];
}